import TrailTable from "components/common/TrailTable/TrailTable";
import React from "react";
import { useAppSelector } from "store";

const ProviderTrailTab = () => {
  const entityId = useAppSelector((store) => store.providers.payload?.id);

  return <TrailTable entityType="provider" entityId={Number(entityId)} />;
};

export default ProviderTrailTab;
